var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReloadBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "88.000000pt",
    height: "88.000000pt",
    viewBox: "0 0 88.000000 88.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,88.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378 790 l-3 -53 -44 -13 c-54 -16 -139 -73 -170 -114 -51 -70 -71 -130 -71 -220 0 -73 4 -94 29 -145 35 -75 95 -136 169 -172 50 -24 69 -28 147 -28 78 0 97 4 147 28 31 15 75 46 98 68 52 51 100 149 100 207 0 38 -2 42 -25 42 -21 0 -25 -5 -25 -28 0 -85 -73 -192 -164 -240 -43 -23 -63 -27 -131 -26 -66 0 -89 5 -131 27 -66 33 -128 104 -150 169 -20 62 -15 177 10 226 27 53 86 112 138 138 67 34 78 32 78 -16 0 -22 4 -40 8 -40 4 0 33 26 65 58 l57 58 -64 63 -65 64 -3 -53z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReloadBlack);
export default __webpack_public_path__ + "static/media/icon-reload-black.821521d4.svg";
export { ForwardRef as ReactComponent };